import { Building2, ArrowRight, Phone, Zap } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICE_AREA } from "@/data/serviceArea";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const PragueServiceBanner = () => {
  const { secondaryRegion } = SERVICE_AREA;

  return (
    <section 
      className="py-10 md:py-14 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 relative overflow-hidden"
      aria-labelledby="prague-heading"
    >
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_30%_20%,rgba(59,130,246,0.3),transparent_50%)]" />
        <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(circle_at_70%_80%,rgba(99,102,241,0.2),transparent_50%)]" />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Header badge */}
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-500/20 text-blue-300 font-semibold text-sm border border-blue-500/30">
              <Building2 className="h-4 w-4" aria-hidden="true" />
              ROZŠIŘUJEME PŮSOBNOST
            </span>
          </div>
          
          {/* Main heading */}
          <h2 
            id="prague-heading" 
            className="text-2xl md:text-3xl lg:text-4xl font-bold text-center text-white mb-3"
          >
            Působíme i v <span className="text-blue-400">Praze</span> a Středočeském kraji
          </h2>
          
          {/* Description */}
          <p className="text-slate-300 text-center text-sm md:text-base max-w-2xl mx-auto mb-6">
            Rozšiřujeme naše elektrikářské služby do hlavního města a okolí.
            <span className="block mt-1 text-slate-400">
              <Zap className="inline h-4 w-4 mr-1 text-primary" aria-hidden="true" />
              Elektroinstalace • Revize • Fotovoltaika • Elektromontáže
            </span>
          </p>
          
          {/* City badges */}
          <div className="flex flex-wrap justify-center gap-2 mb-6">
            {secondaryRegion.cities.map((city) => (
              <Badge 
                key={city.name}
                variant="outline"
                className="bg-slate-700/50 border-slate-600 text-slate-200 hover:bg-slate-700 hover:border-blue-500/50 transition-colors px-3 py-1"
              >
                {city.name}
              </Badge>
            ))}
          </div>
          
          {/* Note + CTA */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
            <p className="text-slate-400 text-sm flex items-center gap-2">
              <span className="inline-block w-2 h-2 rounded-full bg-blue-400 animate-pulse" aria-hidden="true" />
              {secondaryRegion.note}
            </p>
            
            <div className="flex flex-wrap items-center justify-center gap-3">
              <a 
                href="tel:+420732658712"
                className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-slate-900 rounded-lg font-semibold text-sm hover:bg-primary/90 transition-colors shadow-lg shadow-primary/20"
              >
                <Phone className="h-4 w-4" aria-hidden="true" />
                Zavolat
              </a>
              <Link to="/elektrikar-praha">
                <Button 
                  variant="outline" 
                  size="sm"
                  className="border-slate-600 text-slate-200 hover:bg-slate-700 hover:border-blue-500/50 gap-1"
                >
                  Více o službách v Praze
                  <ArrowRight className="h-4 w-4" aria-hidden="true" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PragueServiceBanner;
